import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HttpService } from '../services/http-service';

@Injectable()
export class ModalService {
    constructor(private translate: TranslateService, private httpService: HttpService) {

    }

    confirm(message: string = null): Promise<boolean> {
        if (message == null) {
            message = "Common.PleaseConfirm";
        }
        return new Promise<boolean>(resolve => {
            if (confirm(this.translate.instant(message))) {
                resolve(true);
            } else {
                resolve(false);
            }
        });
    }

    verifySmsCode(message: string = null): Promise<boolean> {
        if (message == null) {
            message = "Podaj kod otrzymany w sms";
        }

        return new Promise<boolean>((resolve, error) => {
            this.httpService.get('api/sms/send-code').subscribe(sentResult => {
                if (sentResult == false) {
                    error(1003);
                }
                else {
                    var code = prompt(message);
                    this.httpService.post('api/sms/verify-code', {
                        code: code
                    }).subscribe(verificationResult => {
                        if (verificationResult) {
                            resolve(true);
                        }
                        else {
                            error(1002);
                        }
                    });
                }
            });
        })
    }

    getSmsCode(message: string = null): Promise<string> {
        if (message == null) {
            message = "Podaj kod otrzymany w sms";
        }

        return new Promise<string>((resolve, error) => {
            this.httpService.get('api/sms/send-code').subscribe(sentResult => {
                if (sentResult == false) {
                    error(1003);
                }
                else {
                    var code = prompt(message);
                    if (code != null) {
                        resolve(code);
                    }
                    else {
                        error(1002);
                    }
                }
            });
        })
    }

    sendSmsCode(): Promise<void> {
        return new Promise((resolve, error) => {
            this.httpService.get('api/sms/send-code').subscribe(sentResult => {
                if (sentResult == false) {
                    error(1003);
                }
                else {
                    resolve();
                }
            });
        })
    }
}
